<template>
  <div class="main-con">
    <table class="data-table">
      <thead>
      <tr>
        <th v-for="header in headers" :key="header.key" :class="header.headerClasses"
            @click="sortOptionChange(header.key)"
        >
          <span>{{ header.title }}</span>
          <template v-if="header.key in sortOptions">
            <v-icon v-if="sortOptions[header.key]" small>
              mdi-arrow-up-thick
            </v-icon>
            <v-icon v-else small>
              mdi-arrow-down-thick
            </v-icon>
          </template>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in tableDataRes" :key="index">
        <td class="">
          {{ dateFormatChange(item.requestDate, 'month') }}
        </td>
        <td class="table-text-center">
          {{ item.accountId }}
        </td>
        <td class="column-size-short" :title="item.accountName">
          {{ item.accountName }}
        </td>
        <td class="column-size-short" :title="item.itemName">
          {{ item.itemName }}
        </td>
        <td class="">
          {{ item.serviceCdName }}
        </td>
        <td class="">
          {{ item.procTypeName }}
        </td>
        <td class="column-size-short" :title="item.paymentStatus">
          {{ item.paymentStatus }}
        </td>
        <td class="column-size-short" :title="item.resultMessage">
          {{ item.resultMessage }}
        </td>
        <td class="table-text-right">
          {{ numberFormat(item.paymentCallAmount) }}
        </td>
        <td class="table-text-right">
          {{ numberFormat(item.paymentActualAmount) }}
        </td>
        <td class="table-text-right">
          {{ numberFormat(item.paymentFee) }}
        </td>
        <td class="column-size-short">
          {{ item.memberId }}
        </td>
        <td class="column-size-short">
          {{ item.memberPayerName }}
        </td>
        <td class="">
          {{ item.cmsStatus }}
        </td>
        <td class="">
          {{ dateFormatChange(item.paymentWithdrawalDatetime, 'month') }}
        </td>
        <td class="">
          {{ dateFormatChange(item.paymentSettlementDatetime, 'month') }}
        </td>
        <td class="column-size-short" :title="item.transactionId">
          {{ item.transactionId }}
        </td>
        <td class="">
          {{ item.depositWithdrawalHistId }}
        </td>
        <td class="">
          {{ item.cardApprovalNumber }}
        </td>
        <td class="">
          {{ dateFormatChange(item.regDatetime) }}
        </td>
        <td class="">
          {{ dateFormatChange(item.uptDatetime) }}
        </td>
        <td class="">
          {{ item.registerUserName }}
        </td>
        <td class="">
          {{ dateFormatChange(item.cpmRegDatetime) }}
        </td>
        <td class="">
          {{ dateFormatChange(item.cpmUptDatetime) }}
        </td>
        <td class="table-text-center">
          {{ item.cpmDeleteYn }}
        </td>
      </tr>
      <v-btn
        :color="disableButton ? 'primary':'#cccccc'"
        dark
        large
        class="add-load-button"
        @click="plusLoadButtonClick"
      >
        추가로드
      </v-btn>
      </tbody>
    </table>
  </div>
</template>

<script>
/**
 * 장치 목록 컴포넌트에서 테이블 부분입니다.
 *
 */
import {DateTime} from "luxon";
import headerDataList from "@/components/TagTable/headerDataList";

export default {
  name: "NoLibraryBagicTable",
  components: {},
  props: {
    tableDataRes: {
      type: Array,
      default: () => []
    },
    disableButton: {
      type: Boolean,
      default: false
    },
    selectOptions: {
      type: Object,
      default: () => {
      }
    },
    sortOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      headers: headerDataList.DEPOSIT_LIST.DEPOSITS
    }
  },
  methods: {
    /**
     * 추가로드 버튼을 클릭시 동작합니다.
     */
    plusLoadButtonClick() {
      if (!this.disableButton) return //데이터가 없을때 추가로드 비활성화 합니다.
      this.$emit('page-number-plus');
    },
    /**
     * type이 date 인 cell은 Utc+9로 변경합니다
     * @param row
     * @returns {*}
     */
    dateFormatChange(date, type) {
      const format = `yyyy-MM-dd ${type !== "month" ? "HH:mm" : ""}`
      if (!date) return undefined
      return DateTime.fromISO(DateTime.fromISO(date, {zone: 'utc'}).toISO()).toFormat(format)
    },
    /**
     * 돈과 연관되있는 데이터는 3번째 자리에서 ,를 찍어줍니다
     * @param number
     * @returns {string}
     */
    numberFormat(number) {
      if (!number) return '0'
      return Number(number).toLocaleString()
    },
    /**
     * 각 칼럼별 헤더를 클릭시 실행되고 칼럼명을 받아 객체에 key value로 저장합니다
     * (처리방식 회원상태 등록자는 정렬에서 제외)
     * true -> 내림차순
     * false -> 오름차순
     * 처음 클릭시 -> true
     * 두부터 클릭시 -> !value(기존데이터)
     */
    sortOptionChange(e) {
      if (!this.selectOptions || !this.selectOptions.rentalcompanyId) return
      if (e === 'procTypeName' || e === 'cmsStatus' || e === 'registerUserName') return
      const changeSortValue = (e in this.sortOptions) ? !this.sortOptions[e] : true
      this.$emit("sort-options-data-change", {[e]: changeSortValue})
    },
  }
}
</script>

<style scoped>

>>> input[type=checkbox] {
  position: absolute;
}

.main-con {
  height: 100%;
  overflow-y: auto;
}

.main-con .data-table {
  table-layout: fixed;
  border-spacing: 0;
  width: 2050px;
  overflow-x: auto;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.top-header-wrapper {
  background: #E5F4FF;
}

.top-header-text {
  border: 1px solid #6f6f6f;
}

.main-con .data-table thead tr th {
  font-size: 11px;
  padding-right: 8px;
}

.main-con .data-table tbody td {
  text-align: left;
  border: 1px solid #ccc;
  font-size: 11px;
  padding: 0.15rem;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

.button-flex-left {
  display: flex;
  justify-content: space-between;
}

.column-size-short {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.width-pixel-40 {
  width: 40px !important;
}

.width-pixel-50 {
  width: 50px !important;
}

.width-pixel-70 {
  width: 70px !important;
}

.width-pixel-90 {
  width: 90px !important;
}

.width-pixel-100 {
  width: 100px !important;
}

.width-percent-2 {
  width: 2% !important;
}

.width-percent-4 {
  width: 4% !important;
}

.width-percent-6 {
  width: 6% !important;
}

.table-text-center {
  text-align: center !important;
}

.table-text-right {
  text-align: right !important;
}
</style>
